'use client';
import PropTypes from 'prop-types';
import * as React from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';
import { assignRefs } from '../../../core/utilities/ref.utils.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const propTypes = {
    /**
   * An indeterminate checkbox means that its state is unclear.
   * Typically, this is used when the checkbox has some sub-options under it.
   */ indeterminate: PropTypes.bool,
    /**
   * If set to true, the checkbox will animate instantly.
   * @default false
   */ instant: PropTypes.bool,
    /**
   * The visual style of the Checkbox.
   * One of: "standard", "favourite".
   * @default standard
   */ skin: PropTypes.oneOf([
        'standard',
        'favorite'
    ])
};
const propKeysToRemove = Object.keys(propTypes);
const Checkbox = renderWithRef('Checkbox', propTypes, (props, ref)=>{
    const { instant = false, skin = 'standard' } = props;
    const classNames = new Set([
        'swan-checkbox'
    ]);
    if (skin == 'favorite') {
        classNames.add('swan-checkbox-skin-favorite');
    }
    if (instant) {
        classNames.add('swan-checkbox-instant');
    }
    const inputRef = React.useRef();
    const finalRef = assignRefs(inputRef, ref);
    React.useEffect(()=>{
        if (inputRef.current) {
            inputRef.current.indeterminate = !!props.indeterminate;
        }
    }, [
        props.indeterminate
    ]);
    return(// TODO: v4 discuss below should it be props={{ ...props, type: 'checkbox' }}
    /*#__PURE__*/ React.createElement(RenderComp, {
        root: "input",
        forwardedRef: finalRef,
        propKeysToRemove: propKeysToRemove,
        classNames: classNames,
        props: _object_spread({
            type: 'checkbox'
        }, props)
    }, props.children));
});

export { Checkbox };
